import { h } from 'preact'
import { useContext } from 'preact/hooks'
import { ForwardFn, forwardRef } from 'preact/compat'
import cls from 'classnames'
import BaseContext from 'contexts/base-context'
import { useParentWindowSize, useTranslation } from 'scripts/hooks'
import classes from './branding.scss'

import howxmImg from './howxm.png'

type Props = {
  brandingUrl: string
}

const Branding: ForwardFn<Props, HTMLDivElement> = ({ brandingUrl }, ref) => {
  const t = useTranslation()
  const { interactive } = useContext(BaseContext)
  const { windowSizeSm } = useParentWindowSize()
  const brandingText = t('branding', '浩客提供技术支持').replace('浩客', '<span>浩客</span>')

  const brandingClasses = cls(classes.branding, {
    [classes.readonly]: !interactive || windowSizeSm,
  })

  return (
    <div className={brandingClasses} ref={ref}>
      <a href={brandingUrl} target="_blank" className={classes.link} rel="noreferrer">
        <img src={howxmImg} width={14} height={14} alt={brandingUrl} className={classes.logo} />
        <span dangerouslySetInnerHTML={{ __html: brandingText }} />
      </a>
    </div>
  )
}

export default forwardRef(Branding)
